import { render } from "./FeedbackApp.vue?vue&type=template&id=a0ee0f62"
import script from "./FeedbackApp.vue?vue&type=script&lang=js"
export * from "./FeedbackApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__